"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundImage = exports.EmptyOrErrorStateContainer = exports.Anchor = exports.ActionButtonWrapper = exports.Subtitle = exports.Title = exports.TitleContainer = exports.SectionContainer = exports.MessagesCenterContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.MessagesCenterContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.space.s200};

  background-color: ${({ theme }) => theme.colors.gray.s200};

  ${({ $isCentered }) => $isCentered &&
    (0, styled_components_1.css) `
      height: 100%;
      align-items: center;
      justify-content: center;
    `};
`;
exports.SectionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s200};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space.s300};
  }
`;
exports.TitleContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  margin-bottom: ${({ theme }) => theme.space.s400};
`;
exports.Title = styled_components_1.default.p `
  margin: 0;

  ${({ theme }) => theme.typography.heading.small};
  color: ${({ theme }) => theme.colors.neutral.n800};

  ${({ $width }) => $width &&
    (0, styled_components_1.css) `
      width: ${$width}px;
    `};
`;
exports.Subtitle = styled_components_1.default.p `
  margin: ${({ theme }) => theme.space.s100} 0 0 0;

  ${({ theme }) => theme.typography.body.regularText};
  color: ${({ theme }) => theme.colors.neutral.n500};

  ${({ $width }) => $width &&
    (0, styled_components_1.css) `
      width: ${typeof $width === 'number' ? `${$width}px` : $width};
    `};
`;
exports.ActionButtonWrapper = styled_components_1.default.div `
  ${({ $width }) => $width &&
    (0, styled_components_1.css) `
      min-width: ${$width}px;
    `};

  ${({ $withMarginBottom, theme }) => $withMarginBottom &&
    (0, styled_components_1.css) `
      margin-bottom: ${theme.space.s200};
    `};

  ${({ $hasWhiteBackground, theme }) => $hasWhiteBackground &&
    (0, styled_components_1.css) `
      background-color: ${theme.colors.white.s100};
    `};
`;
exports.Anchor = styled_components_1.default.a `
  text-decoration: none;
`;
exports.EmptyOrErrorStateContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  background-color: ${({ theme }) => theme.colors.gray.s200};

  ${({ $isMyNotificationsPage }) => $isMyNotificationsPage
    ? (0, styled_components_1.css) `
          margin: ${({ theme }) => `-${theme.space.s400} -${theme.space.s100} 0 -${theme.space.s100}`};

          @media (max-width: ${({ theme }) => theme.breakpoint.tablet}) {
            margin: ${({ theme }) => `-${theme.space.s100} 0 0 0`};
          }
        `
    : (0, styled_components_1.css) `
          justify-content: center;
          padding: ${({ theme }) => theme.space.s200};
        `};
`;
exports.BackgroundImage = styled_components_1.default.div `
  width: 100%;
  height: 280px;

  margin-bottom: ${({ theme }) => theme.space.s400};

  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  background-image: url('${({ $mobileImg }) => $mobileImg}');

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    height: 360px;

    border-radius: ${({ theme }) => `${theme.radius.s300} ${theme.radius.s300} 0 0`};

    background-image: url('${({ $tabletImg }) => $tabletImg}');
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    height: 200px;

    background-image: url('${({ $desktopImg }) => $desktopImg}');
  }
`;
